module.exports = __webpack_public_path__ + "img/top-image-1904x1073.dfba0fc8.jpg";